import React, { useEffect } from "react";
import { Button, Form, Input, Space, Select, Switch } from "antd";
import { Framework } from "../../../types/framework";
import { Plugin } from "../../../types/plugin";

const { Option } = Select;

export interface PluginFormProps {
  plugin?: Plugin;
  isLoading?: boolean;
  onFinish: (plugin: Plugin) => void;
}

export const PluginForm = (props: PluginFormProps) => {
  const [form] = Form.useForm();

  const onReset = () => {
    form.resetFields();
  };

  const onFinish = (values: any) => {
    const plugin: Plugin = { ...props.plugin, ...values };
    props.onFinish(plugin);
  };

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(props.plugin);
  }, [props.plugin, form]);

  return (
    <Form
      form={form}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 16 }}
      layout="horizontal"
      onFinish={onFinish}
    >
      <Form.Item
        label="Status"
        name="status"
        rules={[{ required: true, message: "Please input status" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: "Please input name" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item name="framework" label="Framework">
        <Select style={{ width: 120 }}>
          <Option value={Framework.UNITY}>Unity</Option>
          <Option value={Framework.OTHER}>Other</Option>
        </Select>
      </Form.Item>
      <Form.Item name="version" label="Version">
        <Input />
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
        <Space>
          <Button loading={props.isLoading} type="primary" htmlType="submit">
            {props.plugin ? "Update" : "Create"}
          </Button>
          <Button htmlType="button" onClick={onReset}>
            Reset
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};
